import React from 'react'; 

const projectContext = React.createContext({project:'',selectProject:()=>{}});
    
export default projectContext;